module.exports = __webpack_public_path__ + "img/applelogo.5c0e7b07.png";